import { useKFlags } from '@/hooks/use-k-flags';
import { Flex } from '@chakra-ui/react';
import { FilterType } from './content/filter-config/types';
import { ReportFilter } from './ReportFilter';
import { SelectedFilters } from './selected';

export interface FilterProps {
  filtersToShow: FilterType[];
  selected: any[];
  onReset?: () => void;
  onSave: (_values: any) => void;
  onRemoveFilter?: (_values: any) => void;
  onOpenFilter?: (_values: any) => void;
  filterPopoverActions?: any;
  isReadOnly?: boolean;
  disableClearAll?: boolean;
  showValuesOnTooltip?: boolean;
  styles?: any;
  triggerContent?: string;
  isEditMode?: boolean;
  reportType?: string;
  onClose?: () => void;
}

export const Filter = ({
  onReset = () => {},
  onSave = () => {},
  onRemoveFilter = () => {},
  selected = [],
  filtersToShow = undefined,
  triggerContent = undefined,
  isEditMode = false,
  reportType,
}: FilterProps) => {
  //todo: enable this when product team confirms
  // const filterPopoverActions = useDisclosure({});
  const { feReportsV3 } = useKFlags();
  return (
    <Flex gap={feReportsV3 ? '12px' : '0'}>
      <ReportFilter
        filtersToShow={filtersToShow}
        onSave={onSave}
        onReset={onReset}
        selected={selected}
        triggerContent={triggerContent}
        isEditMode={isEditMode}
        reportType={reportType}
        // filterPopoverActions={filterPopoverActions}
      />
      {feReportsV3 ? (
        <></>
      ) : (
        <SelectedFilters
          selected={selected}
          onRemoveFilter={onRemoveFilter}
          onReset={onReset}
          onOpenFilter={() => {
            // filterPopoverActions?.onOpen();
          }}
        />
      )}
    </Flex>
  );
};
